var exports = {
  "i": "xaee3c4fa--361cb4--wrapper",
};

module.exports = exports;
